import { render } from "./notification-settings.vue?vue&type=template&id=3fb0fdac&scoped=true"
import script from "./notification-settings.vue?vue&type=script&lang=js"
export * from "./notification-settings.vue?vue&type=script&lang=js"

import "./notification-settings.vue?vue&type=style&index=0&id=3fb0fdac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fb0fdac"

export default script